'use strict'

define ['./create_account.css'], () ->
  ($q, $scope, $rootScope, $timeout, $http, $state, $stateParams, RentappService, User, ApplicationTemplate, RENTAPPLICATION_API_URL, $cacheFactory, Flash, $location, $anchorScroll) ->
    $scope.application = $stateParams.application
    $scope.application_template_slug = $stateParams.application_slug
    $scope.params_data = $stateParams.params_data

    $scope.view_state = $stateParams.view_state or 'create'
    $scope.applicant_info = $stateParams.applicant_info

    $scope.mobile_view = window.innerWidth < 768

    if !$scope.application
      $state.go("root.applications.apply", { application_slug: $scope.application_template_slug })

    $scope.$on '$stateChangeStart', (event, toState, toParams, fromState, fromParams) ->
      if toState.name == 'root.applications.apply' and !toParams.application
        event.preventDefault()
        $state.go(toState.name, { application_slug: toParams.application_slug, application: $scope.application, params_data: $scope.params_data })


    $scope.request_passcode = (email) ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/request_passcode/",
        email: email
      .then ->
        $scope.view_state = 'input_code'
        Flash.create('success', 'Email sent!')
      .catch ->
        Flash.create('danger', 'Error has occurred.')

    $scope.confirm_passcode = (email, token) ->
      if !token
        Flash.create('danger', 'Please enter Temporary Passcode Code')
        return
        
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/confirm_passcode/",
        email: email
        token: token
      .then ->
        $scope.view_state = 'create_with_code'
        $scope.passcode_token = token
      .catch ->
        Flash.create('danger', 'Invalid passcode.')

    $scope.set_view_state = (view_state) ->
      $scope.view_state = view_state

    $scope.reset_password = (email) ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/request_password_reset/",
        email: email
      .then ->
        $scope.reset_password_result = 'success'
      .catch ->
        $scope.reset_password_result = 'error'

    $scope.reset_alerts = () ->
      $scope.reset_password_result = null
      $scope.error_message = null

    $scope.submit = (answers) ->
      $scope.submission_errors = null

      new ApplicationTemplate(answers).$submit({id: $scope.application.id})
      .then (response) ->
        application = response
        application_id = response.id
        application_status = response.status
        $cacheFactory.get("$http").removeAll()

        if application.need_applicant_experian_authtoken
          $state.go("root.applications.verify.disclaimer", {application_id: application_id, application: application, context: 'applicant', vendor: 'experian' })
        else if application.need_applicant_smartmove_auth
          $state.go("root.applications.verify.disclaimer", {application_id: application_id, application: application, context: 'applicant', vendor: 'smartmove' })
        else if application.need_applicant_finicity_bank_connection
          $state.go("root.applications.income", {application_id: application_id, application: application })
        else
          $state.go "root.applications.apply_success", {application_id: application_id, application: response }
      .catch (response) ->
        $state.go "root.applications.apply", {application: $scope.application, application_slug: $scope.application_template_slug, submission_errors: response.data}
      .finally () ->
        $scope.submitting_application = false
        $scope.creating_new = false
        $scope.skipping = false

    # with_user == true, if user wants to create user
    # with_user == false, if user wants to skip and continue
    $scope.submit_application = (application, with_user) ->
      $scope.submitting_application = true
      answers = {}

      for section in application.form.sections
        for field in section.fields
            answers[field.name] = field.value

      answers = _.merge(answers, $scope.params_data)

      # Compensating for legacy issue of application templates
      # not having applicant_email field.
      if !$scope.applicant_info
        if !with_user
          $scope.skipping = true
          $scope.submit(answers)
        else
          # Issues with ng-if screwing with ng-model
          username = $scope.signup_form.username.$modelValue
          User.check_available(username: username).$promise
            .then (user_info) ->
              if !user_info.available
                Flash.create("danger", "Username already in use. Please login.", 3000, { class: 'error' }, true)
                $scope.applicant_info = user_info.applicant_info
                $scope.view_state = 'login'
                $scope.submitting_application = false
              else
                $scope.creating_new = true
                answers.applicant_email    = username
                answers.applicant_password = $scope.password
                $scope.submit(answers)
        return

      if $scope.view_state == 'create' or $scope.view_state == 'create_with_code'
        if with_user
          $scope.creating_new = true
          answers.applicant_email    = $scope.applicant_info.email
          answers.applicant_password = $scope.password

          if $scope.view_state == 'create_with_code'
            answers.passcode_token = $scope.passcode_token
          $scope.submit(answers)
        else
          $scope.skipping = true
          $scope.submit(answers)
      else
        $scope.logging_in = true
        $scope.is_locked = false
        $scope.wrong_login = false
        RentappService.login($scope.applicant_info.email, $scope.login_password)
          .then (user) ->
            answers.applicant_email    = $scope.applicant_info.email
            answers.applicant_password = $scope.login_password
            $scope.submit(answers)
          .catch (resp) ->
            $scope.submitting_application = false
            $scope.attempts_max = resp.data.attempts_max
            if resp.data.locked
              Flash.create("danger", "No more than #{$scope.attempts_max} failed login attempts in a 30 minute period are allowed. Please try again later.", 0, { class: 'error' }, true)
            else
              $scope.attempts_left = resp.data.attempts_max - resp.data.attempts_used
              Flash.create("danger", "Sorry, that password isn't right. \n For security reason, after #{$scope.attempts_left} more failed login attempts you'll have to wait 30 minutes before trying again.", 0, { class: 'error' }, true)

            $location.hash('error_messge')
            $anchorScroll()



// WEBPACK FOOTER //
// ./components/applications/create_account/create_account.coffee